import { Modal } from "@shopify/polaris";
import { PlanType } from "./Pricingv2Component";
import { Button } from "@/components/ui/button";
import { MyBillingPlans } from "./BillingPlans";
import { Switch } from "@/components/ui/switch";
import { useState } from "react";

export function DowngradeModal({
  isOpen,
  onClose,
  onDowngrade,
  plans,
  currentPlan,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDowngrade: (plan: PlanType, duration: "monthly" | "yearly") => void;
  plans: PlanType[];
  currentPlan: PlanType | null;
}) {
  const [isAnnual, setIsAnnual] = useState(false);
  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={onClose} title="Change my plan">
      <Modal.Section>
        <div className="bg-white rounded-lg p-6 w-full">
          <h3 className="text-lg font-semibold mb-2">
            Not feeling good about the subscription?
          </h3>
          <p className="text-gray-600 mb-4">
            No worries! You can change to any of these plans:
          </p>
          <div className="flex items-center justify-end gap-2 mb-4">
            <span className="text-sm text-gray-600">Monthly</span>
            <Switch checked={isAnnual} onCheckedChange={setIsAnnual} />
            <span className="text-sm text-gray-600">Annual</span>
          </div>
          <div className="space-y-3">
            {plans.map((plan) => (
              <Button
                key={plan}
                onClick={() => {
                  if (confirm("Are you sure you want to downgrade? This action may remove any excess pinterest sources, and boards that you have created.")) {
                    onDowngrade(plan, isAnnual ? "yearly" : "monthly");
                    onClose();
                  }
                }}
                variant={plan === currentPlan ? "secondary" : "outline"}
                disabled={plan === currentPlan}
                className="w-full py-6 px-4 border rounded-lg hover:bg-gray-50 text-left flex justify-between items-center"
              >
                <span>{plan}</span>
                {plan === PlanType.FREE ? (
                  <span className="text-sm text-gray-500">Forever Free</span>
                ) : plan === currentPlan ? (
                  <span className="text-sm text-gray-500">Current Plan</span>
                ) : (
                  <div className="flex flex-col items-end">
                    <span className="text-sm">
                      $
                      {(
                        (isAnnual
                          ? MyBillingPlans.yearly[plan] / 12
                          : MyBillingPlans.monthly[plan])
                      ).toFixed(2)}
                      /month
                    </span>
                    <span className="text-xs text-gray-500 line-through">
                      ${MyBillingPlans.regular[plan]}/month
                    </span>
                  </div>
                )}
              </Button>
            ))}
          </div>

          <button
            onClick={onClose}
            className="mt-4 w-full py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
      </Modal.Section>
    </Modal>
  );
}
